// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function LotCardTitle$Title(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotCardTitle"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                tl: {
                                  hd: Css.wordWrap(Css.breakWord),
                                  tl: {
                                    hd: Css.textOverflow(Css.ellipsis),
                                    tl: {
                                      hd: Css.overflow(Css.hidden),
                                      tl: {
                                        hd: Css.unsafe("WebkitLineClamp", String(props.numberOfLines)),
                                        tl: {
                                          hd: Css.unsafe("WebkitBoxOrient", "vertical"),
                                          tl: {
                                            hd: Css.unsafe("display", "-webkit-box"),
                                            tl: {
                                              hd: Css.unsafe("color", "inherit"),
                                              tl: /* [] */0
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }),
                          tl: /* [] */0
                        }),
                    children: "" + props.lotNumber + " " + props.title + ""
                  })
            });
}

var Title = {
  make: LotCardTitle$Title
};

function LotCardTitle$Subtitle(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotCardSubtitle"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.unsafe("color", "inherit"),
                                tl: {
                                  hd: Css.textOverflow(Css.ellipsis),
                                  tl: {
                                    hd: Css.whiteSpace(Css.nowrap),
                                    tl: {
                                      hd: Css.overflow(Css.hidden),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }),
                          tl: /* [] */0
                        }),
                    children: props.subtitle
                  })
            });
}

var Subtitle = {
  make: LotCardTitle$Subtitle
};

function LotCardTitle(props) {
  var lotNumber = props.lotNumber;
  var creators = props.creators;
  var subtitle = props.subtitle;
  var lotTitle = props.lotTitle;
  var lotNumber$1 = typeof lotNumber === "object" && lotNumber.NAME === "VisibleLotNumber" ? "" + lotNumber.VAL.lotNumber + "." : "";
  if (creators === undefined) {
    if (subtitle !== undefined) {
      return React.createElement(React.Fragment, undefined, React.createElement(LotCardTitle$Title, {
                      lotNumber: lotNumber$1,
                      title: lotTitle,
                      numberOfLines: 1
                    }), React.createElement(LotCardTitle$Subtitle, {
                      subtitle: subtitle
                    }));
    } else {
      return React.createElement(LotCardTitle$Title, {
                  lotNumber: lotNumber$1,
                  title: lotTitle,
                  numberOfLines: 2
                });
    }
  }
  var title = Belt_Array.joinWith(creators, " | ", (function (creator) {
          return creator;
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(LotCardTitle$Title, {
                  lotNumber: lotNumber$1,
                  title: title,
                  numberOfLines: 1
                }), React.createElement(LotCardTitle$Subtitle, {
                  subtitle: lotTitle
                }));
}

var make = LotCardTitle;

export {
  Title ,
  Subtitle ,
  make ,
}
/* Css Not a pure module */
